"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

function promisify(vol, fn, getResult) {
  if (getResult === void 0) {
    getResult = function getResult(input) {
      return input;
    };
  }

  return function () {
    var args = [];

    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }

    return new Promise(function (resolve, reject) {
      vol[fn].bind(vol).apply(void 0, args.concat([function (error, result) {
        if (error) return reject(error);
        return resolve(getResult(result));
      }]));
    });
  };
}

var FileHandle =
/** @class */
function () {
  function FileHandle(vol, fd) {
    this.vol = vol;
    this.fd = fd;
  }

  FileHandle.prototype.appendFile = function (data, options) {
    return promisify(this.vol, 'appendFile')(this.fd, data, options);
  };

  FileHandle.prototype.chmod = function (mode) {
    return promisify(this.vol, 'fchmod')(this.fd, mode);
  };

  FileHandle.prototype.chown = function (uid, gid) {
    return promisify(this.vol, 'fchown')(this.fd, uid, gid);
  };

  FileHandle.prototype.close = function () {
    return promisify(this.vol, 'close')(this.fd);
  };

  FileHandle.prototype.datasync = function () {
    return promisify(this.vol, 'fdatasync')(this.fd);
  };

  FileHandle.prototype.read = function (buffer, offset, length, position) {
    return promisify(this.vol, 'read', function (bytesRead) {
      return {
        bytesRead: bytesRead,
        buffer: buffer
      };
    })(this.fd, buffer, offset, length, position);
  };

  FileHandle.prototype.readFile = function (options) {
    return promisify(this.vol, 'readFile')(this.fd, options);
  };

  FileHandle.prototype.stat = function (options) {
    return promisify(this.vol, 'fstat')(this.fd, options);
  };

  FileHandle.prototype.sync = function () {
    return promisify(this.vol, 'fsync')(this.fd);
  };

  FileHandle.prototype.truncate = function (len) {
    return promisify(this.vol, 'ftruncate')(this.fd, len);
  };

  FileHandle.prototype.utimes = function (atime, mtime) {
    return promisify(this.vol, 'futimes')(this.fd, atime, mtime);
  };

  FileHandle.prototype.write = function (buffer, offset, length, position) {
    return promisify(this.vol, 'write', function (bytesWritten) {
      return {
        bytesWritten: bytesWritten,
        buffer: buffer
      };
    })(this.fd, buffer, offset, length, position);
  };

  FileHandle.prototype.writeFile = function (data, options) {
    return promisify(this.vol, 'writeFile')(this.fd, data, options);
  };

  return FileHandle;
}();

exports.FileHandle = FileHandle;

function createPromisesApi(vol) {
  if (typeof Promise === 'undefined') return null;
  return {
    FileHandle: FileHandle,
    access: function access(path, mode) {
      return promisify(vol, 'access')(path, mode);
    },
    appendFile: function appendFile(path, data, options) {
      return promisify(vol, 'appendFile')(path instanceof FileHandle ? path.fd : path, data, options);
    },
    chmod: function chmod(path, mode) {
      return promisify(vol, 'chmod')(path, mode);
    },
    chown: function chown(path, uid, gid) {
      return promisify(vol, 'chown')(path, uid, gid);
    },
    copyFile: function copyFile(src, dest, flags) {
      return promisify(vol, 'copyFile')(src, dest, flags);
    },
    lchmod: function lchmod(path, mode) {
      return promisify(vol, 'lchmod')(path, mode);
    },
    lchown: function lchown(path, uid, gid) {
      return promisify(vol, 'lchown')(path, uid, gid);
    },
    link: function link(existingPath, newPath) {
      return promisify(vol, 'link')(existingPath, newPath);
    },
    lstat: function lstat(path, options) {
      return promisify(vol, 'lstat')(path, options);
    },
    mkdir: function mkdir(path, options) {
      return promisify(vol, 'mkdir')(path, options);
    },
    mkdtemp: function mkdtemp(prefix, options) {
      return promisify(vol, 'mkdtemp')(prefix, options);
    },
    open: function open(path, flags, mode) {
      return promisify(vol, 'open', function (fd) {
        return new FileHandle(vol, fd);
      })(path, flags, mode);
    },
    readdir: function readdir(path, options) {
      return promisify(vol, 'readdir')(path, options);
    },
    readFile: function readFile(id, options) {
      return promisify(vol, 'readFile')(id instanceof FileHandle ? id.fd : id, options);
    },
    readlink: function readlink(path, options) {
      return promisify(vol, 'readlink')(path, options);
    },
    realpath: function realpath(path, options) {
      return promisify(vol, 'realpath')(path, options);
    },
    rename: function rename(oldPath, newPath) {
      return promisify(vol, 'rename')(oldPath, newPath);
    },
    rmdir: function rmdir(path) {
      return promisify(vol, 'rmdir')(path);
    },
    stat: function stat(path, options) {
      return promisify(vol, 'stat')(path, options);
    },
    symlink: function symlink(target, path, type) {
      return promisify(vol, 'symlink')(target, path, type);
    },
    truncate: function truncate(path, len) {
      return promisify(vol, 'truncate')(path, len);
    },
    unlink: function unlink(path) {
      return promisify(vol, 'unlink')(path);
    },
    utimes: function utimes(path, atime, mtime) {
      return promisify(vol, 'utimes')(path, atime, mtime);
    },
    writeFile: function writeFile(id, data, options) {
      return promisify(vol, 'writeFile')(id instanceof FileHandle ? id.fd : id, data, options);
    }
  };
}

exports.default = createPromisesApi;